/*
 * Prestige Smooth Scroll
 * -------------------------------------------------------------
 * Lightweight inertia scroll (Lenis-style feel) with no deps.
 * Uses real window.scrollTo (NOT a body transform) so that
 * position: sticky keeps working (the stacking-cards section
 * relies on it).
 *
 * Disabled on touch, reduced-motion, and inside the Shopify
 * theme editor (fighting the editor's own scroll is annoying).
 */
(function () {
  if (window.__prestigeSmoothInit) return;
  window.__prestigeSmoothInit = true;

  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(pointer: coarse)').matches) return; // native on touch

  var target = window.scrollY;
  var current = target;
  var running = false;
  var EASE = 0.1;

  function maxScroll() {
    return document.documentElement.scrollHeight - window.innerHeight;
  }
  function clamp(v) {
    return Math.max(0, Math.min(maxScroll(), v));
  }

  // Bug fix (2026-08-12): the PDP variant drawer (.apdp-drawer-body), the
  // Design Services quote panel (.apdp-qpanel), and the mega-menu all have
  // their own internal overflow-y scroll. This handler used to preventDefault()
  // unconditionally on every wheel event regardless of target, which blocked
  // the browser's native scroll-chaining into those containers entirely — so
  // scrolling while hovering an open drawer/modal moved the page behind it
  // instead of the drawer/modal content. Walk up from the event target and
  // bail out (let the browser handle it natively) if we're inside anything
  // that actually has room to scroll on its own.
  function isInsideScrollable(node) {
    var el = node && node.nodeType === 1 ? node : (node && node.parentElement);
    while (el && el !== document.body && el !== document.documentElement) {
      var cs = getComputedStyle(el);
      if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && el.scrollHeight > el.clientHeight) {
        return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  function onWheel(e) {
    if (e.ctrlKey) return; // let pinch-zoom through
    if (isInsideScrollable(e.target)) return; // let the drawer/modal/menu scroll itself
    e.preventDefault();
    var d = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY; // lines -> px
    target = clamp(target + d);
    if (!running) { running = true; requestAnimationFrame(loop); }
  }

  function loop() {
    current += (target - current) * EASE;
    if (Math.abs(target - current) < 0.5) { current = target; running = false; }
    window.scrollTo(0, current);
    if (running) requestAnimationFrame(loop);
  }

  // Keep in sync when the user scrolls by other means (keyboard, scrollbar,
  // anchor jumps) so the next wheel tick doesn't snap.
  function resync() {
    if (!running) { target = window.scrollY; current = window.scrollY; }
  }

  window.addEventListener('wheel', onWheel, { passive: false });
  window.addEventListener('resize', resync);
  window.addEventListener('keydown', function () { setTimeout(resync, 0); });
  window.addEventListener('load', resync);
})();
